module.exports = __webpack_public_path__ + "static/media/ClorinadorlineaPentair.231a452c.pdf";